import {Component} from '@angular/core';
import {NavigationEnd , NavigationStart , Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {AuthService} from '../../core/services/auth.service';
import {FuseConfigService} from '../../core/services/config.service';
import {map} from 'rxjs/operators';
import {LoaderService} from '../../core/services/loader.service';
import {AppConfig} from '../../app.config';
import { MatDialog } from '@angular/material/dialog';
import {DeviceDetectorService} from 'ngx-device-detector';
import { HttpClient } from '@angular/common/http';
import {ToastrService } from 'ngx-toastr';
import {UserService} from '../../core/services/users.service';
import {LogsService} from '../../core/services/logs.service';
import {PlatformsService} from '../../core/services/platforms.service';
import { EventService } from '../../core/services/event.service';
@Component({
    selector: 'fuse-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    standalone: false
})

export class FuseToolbarComponent {
  userStatusOptions: any[];
  languages: any;
  selectedLanguage: any;
  showLoadingBar: boolean;
  horizontalNav: boolean;
  userName;
  superAdmin;
  user;
  logo;
  impersonation = false;
  organizationName = '';
  organizationType = '';
  city;
  country;
  dialogRef: any;
  websiteInfoLink = 'https://pfefferstern.info/ideen/';
  platforms;
  selectedPlatform;
  constructor (public dialog: MatDialog ,
               private router: Router ,
               private auth: AuthService ,
               private fuseConfig: FuseConfigService ,
               private loaderService: LoaderService ,
               private deviceService: DeviceDetectorService ,
               private http: HttpClient ,
               private userService: UserService ,
               public toastr: ToastrService ,
               private platformsService: PlatformsService,
               private translate: TranslateService , private appConfig: AppConfig,
               private logsService: LogsService, public eventService: EventService) {
    this.userStatusOptions = [
      {
        'title': 'Online' ,
        'icon': 'icon-checkbox-marked-circle' ,
        'color': '#4CAF50'
      } ,
      {
        'title': 'Away' ,
        'icon': 'icon-clock' ,
        'color': '#FFC107'
      } ,
      {
        'title': 'Do not Disturb' ,
        'icon': 'icon-minus-circle' ,
        'color': '#F44336'
      } ,
      {
        'title': 'Invisible' ,
        'icon': 'icon-checkbox-blank-circle-outline' ,
        'color': '#BDBDBD'
      } ,
      {
        'title': 'Offline' ,
        'icon': 'icon-checkbox-blank-circle-outline' ,
        'color': '#616161'
      }
    ];

    this.languages = [
      {
        'id': 'en' ,
        'title': 'English' ,
        'flag': 'en'
      } ,
      {
        'id': 'de' ,
        'title': 'Germany' ,
        'flag': 'de'
      },
      {
        'id': 'fr' ,
        'title': 'French' ,
        'flag': 'fr'
      }
    ];
    this.fuseConfig.projectSettings.subscribe((res: any) => {
      if (res) {
        this.websiteInfoLink = res.websiteInfoLink;
      }
    });
    this.fuseConfig.userName.subscribe((res) => {
      this.userName = res;
    });
    this.fuseConfig.logo.subscribe((res) => {
      if (res && res !== 'null') {
        this.logo = res;
      } else {
        this.logo = '';
      }
    });

    this.fuseConfig.impersonation.subscribe((res) => {
      if (res) {
        this.impersonation = true;
      }
    });

    this.fuseConfig.superAdmin.subscribe((res) => {
      this.superAdmin = res;
    });
    this.fuseConfig.user.subscribe((res) => {
      this.user = res;
    });
    this.fuseConfig.organizationName.subscribe((res) => {
      if (res && res !== 'null') {
        this.organizationName = res;
      } else {
        this.organizationName = '';
      }
    });

    this.fuseConfig.organizationType.subscribe((res) => {
      if (res && res !== 'null') {
        this.organizationType = res;
      } else {
        this.organizationType = '';
      }
    });

    this.fuseConfig.city.subscribe((res) => {
      if (res && res !== 'null') {
        this.city = res;
      } else {
        this.city = '';
      }
    });

    this.fuseConfig.country.subscribe((res) => {
      if (res && res !== 'null') {
        this.country = res;
      } else {
        this.country = '';
      }
    });

    // console.log('test');
    this.selectedLanguage = this.languages.find(obj => {
      return obj.id === (localStorage.getItem('lang') || 'de');
    }) || this.languages[1];
    // console.log(this.selectedLanguage);
    router.events.subscribe(
      (event) => {
        if (event instanceof NavigationStart) {
          this.showLoadingBar = true;
        }
        if (event instanceof NavigationEnd) {
          this.showLoadingBar = false;
        }
      });

    loaderService.loader.subscribe((res) => {
      this.showLoadingBar = res;
    });

    this.fuseConfig.onSettingsChanged.subscribe((settings) => {
      this.horizontalNav = settings.layout.navigation === 'top';
    });

    this.fuseConfig.platforms.subscribe(platform => {
      this.platforms = platform;
      if (this.platforms && this.platforms.length) {
        this.selectPlatform(this.platforms[0]);
      } else {
        this.selectPlatform(null);
      }
    });

    this.fuseConfig.selectedPlatform.subscribe((selectedPlatform) => {
      this.selectedPlatform = selectedPlatform;
      if (this.selectedPlatform) {
        this.fuseConfig.toolbarColor.next(this.selectedPlatform.color);
      } else {
        this.fuseConfig.toolbarColor.next(null);
      }
    });
  }

  selectPlatform(platform) {
    this.fuseConfig.selectPlatform(platform);
    this.fuseConfig.selectedPlatformId_Sig.set(platform?.id || null);
  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }

  search (value) {
    // Do your search here...
    console.log(value);
  }

  setLanguage (lang) {
    // Set the selected language for toolbar
    this.selectedLanguage = lang;

    // Use the selected language for translations
    this.translate.use(lang.id);
  }

  logOut () {
    this.logsService.addLogs('logout').subscribe(resultLog => {

    });
    this.auth.logout().then(() => {
      this.fuseConfig.setImpersonation(null);
    });
  }

  openDocumentation () {
    this.fuseConfig.setDocumentation(Date.now());
  }

  logIn () {
    const token = localStorage.getItem('oldToken');
    this.auth.loginBack({token: token}).pipe(map(
      (res) => {
        if (res[ 'error' ]) {
        } else {
          console.log('Done');
          this.auth.setSession(res);
          this.fuseConfig.setToken(res[ 'accessToken' ]);
          localStorage.setItem('name' , res[ 'lastName' ] + ' ' + res[ 'firstName' ]);
          localStorage.setItem('id' , res[ 'id' ]);
          localStorage.setItem('canRecommend' , res[ 'canRecommend' ]);
          localStorage.setItem('allowCompetency' , res[ 'allowCompetency' ]);
          localStorage.setItem('role' , res[ 'role' ].name);
          localStorage.setItem('eCall' , res[ 'eCall' ]);
          localStorage.setItem('whatsapp' , res[ 'whatsapp' ]);
          localStorage.setItem('organizationId' , res[ 'organizationId' ]);
          localStorage.setItem('logo' , res[ 'logo' ]);
          localStorage.setItem('lang' , res[ 'lang' ]);
          localStorage.setItem('privacy' , res[ 'privacy' ]);
          localStorage.setItem('userEmail', res['email']);
          if (res.hasOwnProperty('organizationName')) {
            localStorage.setItem('organizationName' , res[ 'organizationName' ]);
            this.fuseConfig.setOrganizationName(res[ 'organizationName' ]);
          } else {
            localStorage.setItem('organizationName' , '');
            this.fuseConfig.setOrganizationName('');
          }

          if (res.hasOwnProperty('organizationType')) {
            localStorage.setItem('organizationType' , res[ 'organizationType' ]);
            this.fuseConfig.setOrganizationType(res[ 'organizationType' ]);
          } else {
            localStorage.setItem('organizationType' , '');
            this.fuseConfig.setOrganizationType('');
          }

          if (res.hasOwnProperty('country')) {
            localStorage.setItem('country' , JSON.stringify(res[ 'country' ]));
            this.fuseConfig.setCountry(res[ 'country' ]);
          } else {
            localStorage.setItem('country' , '');
            this.fuseConfig.setCountry('');
          }

          if (res.hasOwnProperty('city')) {
            localStorage.setItem('city' , JSON.stringify(res[ 'city' ]));
            this.fuseConfig.setCity(res[ 'city' ]);
          } else {
            localStorage.setItem('city' , '');
            this.fuseConfig.setCity('');
          }
          if (res.hasOwnProperty('organizationName')) {
            localStorage.setItem('organizationName' , res[ 'organizationName' ]);
            this.fuseConfig.setOrganizationName(res[ 'organizationName' ]);
            this.organizationName = res[ 'organizationName' ];
          } else {
            localStorage.setItem('organizationName' , '');
            this.fuseConfig.setOrganizationName('');
            this.organizationName = '';
          }

          localStorage.removeItem('impersonation');
          this.translate.use(localStorage.getItem('lang'));
          this.fuseConfig.setUserName(res[ 'lastName' ] + ' ' + res[ 'firstName' ]);
          this.fuseConfig.setUserId(res[ 'id' ]);
          this.fuseConfig.userId_Sig.set(res['id']);
          this.fuseConfig.setCanRecommend(res[ 'canRecommend' ]);
          this.fuseConfig.setAllowCompetency(res[ 'allowCompetency' ]);
          this.fuseConfig.setRole(res[ 'role' ].name);
          this.fuseConfig.role_Sig.set(res['role'].name);
          this.fuseConfig.setECall(res[ 'eCall' ]);
          this.fuseConfig.setWhatsApp(res[ 'whatsapp' ]);
          this.fuseConfig.setUserEmail(res['email']);
          if (res[ 'role' ].name === 'organisationAdmin') {
            this.fuseConfig.setOrganizationId(res[ 'organizationId' ]);
            this.fuseConfig.organizationId_Sig.set(res['organizationId']);
            this.platformsService.getByOrganizationId(res['organizationId'], true).subscribe(platform => {
              this.fuseConfig.setPlatforms(platform);
            });
          } else {
            this.fuseConfig.setOrganizationId(null);
            this.fuseConfig.organizationId_Sig.set(null);
            this.fuseConfig.setPlatforms(null);
          }
          this.fuseConfig.setLogo(res[ 'logo' ]);
          this.fuseConfig.setPrivacy(res[ 'privacy' ]);
          // this.fuseConfig.setOrganizationName(res['organizationName'] ? res['organizationName'] : '');
          this.appConfig.setAuthToken(res[ 'accessToken' ]);
          this.fuseConfig.setImpersonation(null);
          this.impersonation = false;
          setTimeout(() => {
            this.router.navigate([ '/' ]);
          } , 1500);

        }
      })).subscribe();
  }

  navigateToProfile () {
    this.router.navigate([ '/pages/profile' ]);
  }
  navigateToPrivacy () {
    this.router.navigate([ '/pages/privacy' ]);
    this.router.navigate([ '/pages/privacy' ]);
  }
}
